import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { hasAllApproves } = {}) => {
  const approveAllColor = hasAllApproves
    ? colors.gilead.primary2
    : colors.gilead.primary1;

  return {
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          marginBottom: theme.spacing(1),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          marginBottom: theme.spacing(2),
        }),
      },
    },
    h1: {
      fontSize: 28,
      [theme.breakpoints.down('md')]: {
        fontSize: 22,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 22,
        }),
      },
    },
    h2: {
      [theme.breakpoints.down('lg')]: {
        fontSize: 18,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          fontSize: 18,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 16,
        }),
      },
    },
    approveAllButton: {
      color: `${approveAllColor} !important`,
      fontSize: 14,
      '& svg path': {
        stroke: approveAllColor,
      },
      padding: 0,
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
        padding: 4,
        '& svg': {
          height: 10,
          width: 10,
        },
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 10,
          padding: 4,
          '& svg': {
            height: 10,
            width: 10,
          },
        }),
      },
    },
    submitButton: {
      marginLeft: 'auto',
      marginTop: theme.spacing(3.5),
      minWidth: 146,
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: 44,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
    },
  };
});
